import { API } from "../config/api";
import { DataService } from "../config/dataService/dataService";

export class AdminService {
  static async manageAccount(accountId) {
    const params = { accountId };
    const { data } = await DataService.post(`${API.admin.root}/${API.admin.account}`, params);
    return {
      success: data.success,
    };
  }

  static async getSessions({ idUser, page, accountId }) {
    const queryParams = { idUser, page, accountId };
    const { data } = await DataService.get(`${API.admin.root}/${API.admin.sessions}`, queryParams);
    return {
      sessions: data.sessions,
      total: data.total,
      pageSize: data.pageSize,
      page: data.page,
    };
  }

  static async revokeSession(sessionId) {
    const { data } = await DataService.delete(`${API.admin.root}/${API.admin.sessions}/${sessionId}`);
    return data;
  }
}